import React from 'react'

const Footer = () => {
  return (
    <div className='fixed flex space-x-2 justify-center bottom-0 left-0 w-full bg-primary text-fourth font-mont text-sm'>
      <p>Powered by Revenza Tech Pvt. Ltd.</p>
      <p>+91 7417004118</p>
    </div>
  )
}

export default Footer
